import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatLegacySelectChange as MatSelectChange } from '@angular/material/legacy-select';
import { Observable, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';

// Interfaces
import { ICategory, ISubCategory } from '../../../rfq/interfaces';
import { OptionInterface } from '../../../shared/interfaces';

// Services
import { RfqApiService } from '../../../shared/services/api/rfq/rfq-api.service';
import { trackByValue } from '../../../shared/util';

@Component({
  selector: 'lum-filter-category',
  templateUrl: './filter-category.component.html',
  styleUrls: ['./filter-category.component.scss'],
})
export class FilterCategoryComponent implements OnInit {
  @Input()
  label :string = '';

  @Input()
  value :any = '';

  @Input()
  isSubcategory :boolean = false;

  @Output()
  onCategorySelect :EventEmitter<ICategory> = new EventEmitter<ICategory>();

  categories :ICategory[] = [];
  options :OptionInterface[] = [];

  categories$ :Observable<ICategory[]>;
  subCategories$ :Observable<ISubCategory[]>;

  trackByValue = trackByValue;

  private onDestroy$ = new Subject();

  constructor(private rfqApiService :RfqApiService) {}

  ngOnInit() :void {
    this.initActions();
    this.getDataFromService();
    this.initSubscribers();
  }

  ngOnDestroy() :void {
    this.onDestroy$.next(null);
    this.onDestroy$.complete();
  }

  onSelectCategory(event :MatSelectChange) :void {
    this.onCategorySelect.emit(event.value);
  }

  private getDataFromService() :void {
    this.categories$ = this.rfqApiService.categories$;
    this.subCategories$ = this.rfqApiService.subCategories$;
  }

  private initActions() :void {
    this.options = [];

    if (!this.isSubcategory) {
      this.rfqApiService.getCategories({});
    } else {
      this.rfqApiService.getSubcategories({});
    }
  }

  private initSubscribers() :void {
    if (this.isSubcategory) {
      this.getSubcategoriesFromServices().subscribe();
    } else {
      this.getCategoriesFromServices().subscribe();
    }
  }

  private getCategoriesFromServices() :Observable<any> {
    return this.categories$.pipe(
      tap((categories :ICategory[]) => {
        this.categories = categories;
        this.options = categories.map((row) => {
          return {
            label: row.product_category,
            value: String(row.id),
          };
        });
      }),
    );
  }

  private getSubcategoriesFromServices() :Observable<ISubCategory[]> {
    return this.subCategories$.pipe(
      tap((subCategories :ISubCategory[]) => {
        this.options = subCategories.map((row) => {
          return {
            label: row.sub_category,
            value: String(row.id),
          };
        });
      }),
    );
  }
}
